/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Link, generateName } from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './linkcontrol_styles';



/* ========== ~~~~~~~~~~ LINK CONTROL ~~~~~~~~~~ ========== */
const LinkControl = injectSheet(styles)((props) => {
    const handleClick = () => props.handleSelect(props.value);
    return(
        <div className={`linkcontrol ${props.classes.linkcontrol} selected-${props.selected} disabled-${props.disabled} name-ctl-${generateName(props.text)}`} onClick={handleClick}>
            <Link disabled={props.disabled} text={props.text}/>
        </div>
    )
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default LinkControl;
